export default "__VITE_ASSET__C0nOy3xe__"